<template>
  <el-container class="is-vertical" style="flex-shrink: 0">
    <el-main class="login-register">
      <div class="headings">
        <h2>Hello!</h2>
        <h3>Sorry, some 404 action here - nothing to see.</h3>
      </div>

    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'Page404',
    data () {
      return {
        
      }
    },
    methods: {},
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/Page404.vue